import { Container } from 'unstated';

class SupportButtonStateContainer extends Container {
  state = {
    isLoaded: false,
    isLoggedIn: false,
    firstName: '',
    familyName: '',
    email: '',
  };

  setIsLoaded(isLoaded) {
    this.setState({ isLoaded });
  }
}

export default SupportButtonStateContainer;
